import React from 'react';
import { Linkedin, Mail, Github } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div>
              <div className="text-2xl font-bold mb-4">
                <span className="text-white">AK</span>
                <span className="text-gray-400">.</span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">
                Executive Search Specialist & Developer combining recruitment expertise with custom technology solutions.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <nav className="space-y-2">
                <a href="#about" className="block text-gray-500 hover:text-white transition-colors text-sm">
                  About
                </a>
                <a href="#experience" className="block text-gray-500 hover:text-white transition-colors text-sm">
                  Experience
                </a>
                <a href="#projects" className="block text-gray-500 hover:text-white transition-colors text-sm">
                  Projects
                </a>
                <a href="#skills" className="block text-gray-500 hover:text-white transition-colors text-sm">
                  Skills
                </a>
              </nav>
            </div>

            {/* Connect */}
            <div>
              <h4 className="text-white font-semibold mb-4">Connect</h4>
              <div className="flex gap-4">
                <a
                  href={personalInfo.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-900 hover:bg-white text-white hover:text-black w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="bg-gray-900 hover:bg-white text-white hover:text-black w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                  aria-label="Email"
                >
                  <Mail className="w-5 h-5" />
                </a>
                <a
                  href="https://github.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-900 hover:bg-white text-white hover:text-black w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300"
                  aria-label="GitHub"
                >
                  <Github className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-900">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-600 text-sm">
                © {currentYear} Ahmet Kadayıfçı. All rights reserved.
              </p>
              <p className="text-gray-600 text-sm">
                Built with <span className="text-white">React</span> & <span className="text-white">TailwindCSS</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
